/* eslint-disable no-underscore-dangle */
/*
 * @Author: lipengcheng
 * @Date: 2023-05-19 17:19:24
 * @LastEditTime: 2023-12-20 18:32:58
 * @Description: 获取菜单、处理菜单数据、权限点 等方法文件
 */
import api from '../api/apifolder';
import store from '../store';

const $api = api;
const $store = store;

const getAPIType = () => {
  if (process.env.VUE_APP_MODE === 'master' || process.env.VUE_APP_MODE === 'dev') {
    return '1';
  } else if (process.env.VUE_APP_MODE === 'masternew') {
    return '2'; // 鹰潭
  } else if (process.env.VUE_APP_MODE === 'mastersw') {
    return '3';  // 省外
  }
  return '无法匹配当前环境';
}

class MenuListOperated {
  constructor() {
    this.btnCodeList = {};
    this.menuList = [];
    // eslint-disable-next-line no-nested-ternary
    this.envKey = +getAPIType() === 1 || +getAPIType() === 4
        ? 'xq5'
        : +getAPIType() === 2
        ? 'xq556'
        : 'xq668';
  }

  // eslint-disable-next-line class-methods-use-this
  disposeBtnCode(list) {
    // 处理按钮code数据
    const btnArr = [];
    list.forEach((l) => {
      if (l.status === 1 && l.visible === 1) {
        const p = l.perm.split(':');
        btnArr.push(p[p.length - 1]);
      }
    });
    return btnArr;
  }

  getBtnList(list, newList = []) {
    list.forEach((item) => {
      const c = item.children || [];
      if (item.menuType === 2 && c.length) {
        // 菜单
        this.btnCodeList[item.menuID] = this.disposeBtnCode(c);
      }
      if (c) {
        this.getBtnList(c, newList);
      }
    });
  }

  async getMenuList() {
    await $api.getMenuList({ platformKey: 'wxopappsvr', envKey: this.envKey }).then(async ({ data }) => {
      if (data && +data.code === 0) {
        this.getBtnList(data.data.list);
        const gameId = +$store.state.game_id
        const menuList = data.data.list || []
        await this.disposeMenuGameId(menuList, gameId)
        this.menuList = menuList
        $store.commit('setBtnData', this.btnCodeList); // 设置按钮权限点
        $store.commit('setMenuList', this.menuList || []); // 设置菜单
      } else {
        throw new Error(data.errmsg);
      }
    })
    .catch((err) => {
      console.log(err);
      console.log('获取菜单数据异常');
      // const encrypt = window.btoa(encodeURIComponent(window.location.href));
      // window.location = `http://login.${envKey}.com?request_url=${encrypt}&token_in_url=1`;
    });
  }

  async disposeMenuGameId(data, gameId) {
    data.forEach((list) => {
      if (list.visible === 1 && list.children && list.children.length) { // menuType:1模块 2菜单 3按钮 visible: 1显示2隐藏
        const lc = list.children;
        if (list.gameIDs.length) {
          if (!list.gameIDs.includes(+gameId)) list.visible = 2 // 如绑定了游戏id，则
        }
        this.disposeMenuGameId(lc, gameId);
      } else {
        if (list.gameIDs.length) {
          if (!list.gameIDs.includes(+gameId)) list.visible = 2 // 如绑定了游戏id，则
        }
      }
    })
  }

  disposeAutocompleteData() { // 处理菜单搜索input数据
    const gameId = +$store.state.game_id
    const result = [];
    $store.state.menuOperate.menuList.forEach((list) => {
      if (list.visible === 1 && list.menuType === 1 && list.children && list.children.length) { // menuType:1模块
        const lc = list.children;
        this.disposeMenuFlat(lc, result, list.menuName, gameId);
      } else if (list.visible === 1 && list.menuType === 2) {
        if (list.gameIDs.length) {
          if (list.gameIDs.includes(+gameId)) { // 处理绑定游戏id的菜单
            result.push({
              path: list.path,
              model: list.menuName,
              value: list.menuName,
              menuID: list.menuID
            });
          }
        } else {
          result.push({
            path: list.path,
            model: list.menuName,
            value: list.menuName,
            menuID: list.menuID
          });
        }
      }
    });
    return result;
  }

  disposeMenuFlat(lc, result, menuName, gameId) {
    lc.forEach((c) => {
      if (c.visible === 1) {
        if (c.menuType === 1 && c.children && c.children.length) {
          this.disposeMenuFlat(c.children, result, c.menuName, gameId);
        }
        if (c.menuType === 2) {
          if (c.gameIDs.length) {
            if (c.gameIDs.includes(+gameId)) {
              result.push({
                path: c.path,
                model: menuName,
                value: c.menuName,
                menuID: c.menuID,
              });
            }
          } else {
            result.push({
              path: c.path,
              model: menuName,
              value: c.menuName,
              menuID: c.menuID,
            });
          }
        }
      }
    });
  }

  // eslint-disable-next-line class-methods-use-this
  $btnAuth(code) { // code：按钮code
    // 全局处理控制按钮是否显示
    const ID = $store.state.menuOperate.currentMenusID;
    const codeList = $store.state.menuOperate.btnData; // this.btnCodeList;
    if (code) return codeList[+ID] && codeList[+ID].includes(code);
    return codeList[+ID] && codeList[+ID].includes('writable');
  }
}
const menuOperated = new MenuListOperated();
export default menuOperated;
